import { render } from "./AdminView.vue?vue&type=template&id=6bc58d06&scoped=true"
import script from "./AdminView.vue?vue&type=script&lang=js"
export * from "./AdminView.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6bc58d06"

export default script